/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Directive, Input, ElementRef, Renderer, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { OnInit, OnDestroy, OnChanges, AfterViewInit, ComponentFactoryResolver, ApplicationRef, Injector } from '@angular/core';
import { placements, getPlacements } from './placements';
import { getPopupClassNameFromAlign, getAlignFromPlacement } from '../trigger/utils';


import { Popup } from '../trigger/popup';
import { Trigger } from '../trigger/trigger';
/**
 * Tooltip
 */
export class Tooltip extends Popup {
/**
 * 提示文字
 */
title: string;
/**
 * 箭头是否指向目标元素中心
 */
arrowPointAtCenter = false;

     arrowContent: string;

     builtinPlacements: Object = placements;
/**
 * @return {?}
 */
get arrowClass(): string {
        return `${this.prefixCls}-arrow`;
    }
/**
 * @return {?}
 */
get innerClass(): string {
        return `${this.prefixCls}-inner`;
    }
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 * @param {?} _componentFactoryResolver
 * @param {?} _appRef
 * @param {?} _injector
 */
constructor(
private _renderer: Renderer,
private _elementRef: ElementRef,
private _componentFactoryResolver: ComponentFactoryResolver,
private _appRef: ApplicationRef,
private _injector: Injector) {
        super(_renderer, _elementRef);
    }
/**
 * @return {?}
 */
getPlacements() {
        if (this.arrowPointAtCenter) {
            return getPlacements({
                arrowPointAtCenter: this.arrowPointAtCenter,
                verticalArrowShift: 8,
            });
        }
        return this.builtinPlacements;
    }
/**
 * @param {?} align
 * @return {?}
 */
getClassNameFromAlign(align: any): any {
        const /** @type {?} */ classes = [];
        if (this.arrowPointAtCenter) {
            const /** @type {?} */ placements = this.getPlacements();
            if (this.placement && placements) {
                classes.push(getPopupClassNameFromAlign(placements, this.prefixCls, align));
            }
            return classes.join(' ');
        }

        return super.getClassNameFromAlign(align);
    }
/**
 * @return {?}
 */
getAlign(): {} {
        if (this.arrowPointAtCenter) {
            const /** @type {?} */ placements = this.getPlacements();
            if (this.placement && placements) {
                return getAlignFromPlacement(placements, this.placement, this.align);
            }
        }

        return super.getAlign();
    }
/**
 * 动态设置动画点
 * 
 * @override override from Popup and Align Component
 * @param {?} align 参考https://www.npmjs.com/package/dom-align
 * @return {?}
 */
onAlign(align: any): void {
        super.onAlign(align);

        const /** @type {?} */ placements = this.getPlacements();
        // 当前返回的位置
        const /** @type {?} */ placement = Object.keys(placements).filter(
            key => (
                placements[key].points[0] === align.points[0] &&
                placements[key].points[1] === align.points[1]
            ),
        )[0];
        if (!placement) {
            return;
        }

        // 根据当前坐标设置动画点
        const /** @type {?} */ el = super.getHostElement();
        const /** @type {?} */ rect = el.getBoundingClientRect();
        const /** @type {?} */ transformOrigin = {
            top: '50%',
            left: '50%',
        };
        if (placement.indexOf('top') >= 0 || placement.indexOf('Bottom') >= 0) {
            transformOrigin.top = `${rect.height - align.offset[1]}px`;
        } else if (placement.indexOf('Top') >= 0 || placement.indexOf('bottom') >= 0) {
            transformOrigin.top = `${-align.offset[1]}px`;
        }
        if (placement.indexOf('left') >= 0 || placement.indexOf('Right') >= 0) {
            transformOrigin.left = `${rect.width - align.offset[0]}px`;
        } else if (placement.indexOf('right') >= 0 || placement.indexOf('Left') >= 0) {
            transformOrigin.left = `${-align.offset[0]}px`;
        }
        el.style.transformOrigin = `${transformOrigin.left} ${transformOrigin.top}`;
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-tooltip',
    template: `
        <div #mask
           [ngStyle]="getZIndexStyle()"
           [ngClass]="getMaskClassName()"></div>
        <div #popup [style]="popupStyle"
           [ngStyle]="getZIndexStyle()"
           [ngClass]="getPopupClassName()"
           (mouseEnter)="onMouseEnter($event)" (mouseLeave)="onMouseLeave($event)">
            <div [class]="arrowClass">{{arrowContent}}</div>
            <div [class]="innerClass">{{title}}</div>
        </div>
    `,
    styleUrls: ['./style/index.scss'],
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: ComponentFactoryResolver, },
{type: ApplicationRef, },
{type: Injector, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'title': [{ type: Input },],
'arrowPointAtCenter': [{ type: Input },],
'arrowContent': [{ type: Input },],
'builtinPlacements': [{ type: Input },],
};
}

function Tooltip_tsickle_Closure_declarations() {
/** @type {?} */
Tooltip.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Tooltip.ctorParameters;
/** @type {?} */
Tooltip.propDecorators;
/**
 * 提示文字
 * @type {?}
 */
Tooltip.prototype.title;
/**
 * 箭头是否指向目标元素中心
 * @type {?}
 */
Tooltip.prototype.arrowPointAtCenter;
/** @type {?} */
Tooltip.prototype.arrowContent;
/** @type {?} */
Tooltip.prototype.builtinPlacements;
/** @type {?} */
Tooltip.prototype._renderer;
/** @type {?} */
Tooltip.prototype._elementRef;
/** @type {?} */
Tooltip.prototype._componentFactoryResolver;
/** @type {?} */
Tooltip.prototype._appRef;
/** @type {?} */
Tooltip.prototype._injector;
}

/**
 * 用法：
 * 1. 简单用法：<span antTooltip title="prompt text">Tooltip will show when mouse enter.</span>
 * 2. 按钮用法：
 * <ant-button antTooltip placement="topLeft" title="Prompt Text" [arrowPointAtCenter]="true">
 *     箭头指向中心 (Arrow points to center)
 * </ant-button>
 */
export class TooltipTrgger extends Trigger implements OnInit, OnDestroy, OnChanges, AfterViewInit {

     title: string;
/**
 * 箭头是否指向目标元素中心
 */
arrowPointAtCenter = false;

     mouseEnterDelay = 0.1;
     mouseLeaveDelay = 0.1;
/**
 * @param {?} overlayClass
 * @return {?}
 */
set overlayClass(overlayClass: string) {
        this.popupClass = overlayClass;
    }
/**
 * @param {?} overlayStyle
 * @return {?}
 */
set overlayStyle(overlayStyle: any) {
        this.popupStyle = overlayStyle;
    }

     transitionName = 'zoom-big-fast';

     openClass: string;
/**
 * @param {?} trigger
 * @return {?}
 */
set trigger(trigger: 'hover' | 'focus' | 'click') {
        this.action = [trigger];
    };
/**
 * @param {?} renderer
 * @param {?} elementRef
 * @param {?} componentFactoryResolver
 * @param {?} appRef
 * @param {?} injector
 */
constructor(
private renderer: Renderer,
private elementRef: ElementRef,
private componentFactoryResolver: ComponentFactoryResolver,
private appRef: ApplicationRef,
private injector: Injector) {
        super(renderer, elementRef, componentFactoryResolver, appRef, injector);
        this.trigger = 'hover';
    }
/**
 * @return {?}
 */
ngOnInit(): void {
        this.popupComponentType = Tooltip; // 设定冒泡的类型为指定的类型
        super.ngOnInit();
    }
/**
 * @return {?}
 */
ngOnDestroy(): void {
        super.ngOnDestroy();
    }
/**
 * @return {?}
 */
ngAfterViewInit(): void {
        // prevent the default `title` html action
        this.renderer.setElementAttribute(this.elementRef.nativeElement, 'title', null);
        super.ngAfterViewInit();
    }
/**
 * @return {?}
 */
afterRenderPopupComponent(): void {
        super.afterRenderPopupComponent();
        super.setPopupAttribute('title', this.title);
        super.setPopupAttribute('arrowPointAtCenter', this.arrowPointAtCenter);
    }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (changes['title']) {
            super.setPopupAttribute('title', this.title);
        }
        if (changes['arrowPointAtCenter']) {
            super.setPopupAttribute('arrowPointAtCenter', this.arrowPointAtCenter);
        }
    }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[antTooltip]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: ComponentFactoryResolver, },
{type: ApplicationRef, },
{type: Injector, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'title': [{ type: Input },],
'arrowPointAtCenter': [{ type: Input },],
'mouseEnterDelay': [{ type: Input },],
'mouseLeaveDelay': [{ type: Input },],
'overlayClass': [{ type: Input },],
'overlayStyle': [{ type: Input },],
'transitionName': [{ type: Input },],
'openClass': [{ type: Input },],
'trigger': [{ type: Input },],
};
}

function TooltipTrgger_tsickle_Closure_declarations() {
/** @type {?} */
TooltipTrgger.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TooltipTrgger.ctorParameters;
/** @type {?} */
TooltipTrgger.propDecorators;
/** @type {?} */
TooltipTrgger.prototype.title;
/**
 * 箭头是否指向目标元素中心
 * @type {?}
 */
TooltipTrgger.prototype.arrowPointAtCenter;
/** @type {?} */
TooltipTrgger.prototype.mouseEnterDelay;
/** @type {?} */
TooltipTrgger.prototype.mouseLeaveDelay;
/** @type {?} */
TooltipTrgger.prototype.transitionName;
/** @type {?} */
TooltipTrgger.prototype.openClass;
/** @type {?} */
TooltipTrgger.prototype.renderer;
/** @type {?} */
TooltipTrgger.prototype.elementRef;
/** @type {?} */
TooltipTrgger.prototype.componentFactoryResolver;
/** @type {?} */
TooltipTrgger.prototype.appRef;
/** @type {?} */
TooltipTrgger.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
